<template>
  <div class="inlineGalleryCard">
    <img
      :src="path"
      class="inlineImage"
      :class="{
        'isZoomed' : zoomed,
        'isHigh' : isHigh,
        }"
      :style="tinyImg"
      @click="toggleZoom()"
      ref="img"
    >
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
  },
  name: '',
  props: {
    path: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isHigh: false,
      isZoomed: false,
    };
  },
  computed: {
    ...mapGetters(['imageZoomed', 'currentPlayerImages']),
    imagesAvailable() {
      return this.currentPlayerImages !== null;
    },
    imageLoaded() {
      return this.$refs.img !== undefined && this.$refs.img.naturalHeight > 0;
    },
    zoomed() {
      return this.isZoomed;
    },
    tinyImg() {
      return {
        backgroundImage: `url(${this.getTinyPath()})`,
      };
    },
    /* imageHotspot() {
      return (this.imagesAvailable
        ? this.images[this.curImageId].hotspot
        : { x: 50, y: 50 });
    }, */
  },
  methods: {
    ...mapActions(['setImageZoomed']),
    toggleZoom() {
      this.isZoomed = !this.isZoomed;
      this.setImageZoomed(this.isZoomed);
    },
    getTinyPath() {
      const paths = this.path.split('/');
      const file = paths[paths.length - 1].split('.');
      return `./exhibits/img/tiny/${file[0]}-min.${file[1]}`;
    },
  },
  watch: {
    imageZoomed(newValue) {
      if (!newValue) {
        this.isZoomed = false;
      }
    },
  },
  updated() {
    const height = this.$refs.img.naturalHeight;
    const width = this.$refs.img.naturalWidth;
    const ratio = width / height;
    if (height > width
      && (window.innerHeight * 0.01 * 86) * ratio < window.innerWidth) {
      this.isHigh = true;
    }
  },
};
</script>

<style scoped lang="scss">
.inlineGalleryCard {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .inlineImage {
    margin: 0 auto;
    max-width: 95%;
    max-height: 56vh;
    max-height: calc(var(--vh, 1vh) * 56);
    background-size: cover;
    background-position: center;

    &.isZoomed {
      position: absolute;
      left: 0;
      top: 0;
      max-width: none;
      max-height: none;
      height: 86vh;
      height: calc(var(--vh, 1vh) * 86);
      width: auto;

      &.isHigh {
        height: auto;
        width: 100vw;
      }
    }
  }
}
@media only screen and (orientation : landscape) {
  .inlineGallery {
    .inlineImage {
      &.isZoomed {
        height: auto;
        width: 100vw;
        max-width: 1440px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}
</style>
